// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__gsvxf","title":"AfterBackImages_title__ZWKJg","images":"AfterBackImages_images__3uMBU"};